import { useMutation, useQueryClient } from '@tanstack/react-query';
import { failPcmpProposalAccounts } from '../api/pcmpProposals.api';
import { PCMP_ACCOUNTS_ACTION_COPY } from '../constants/pcmpAccounts.constants';
import type { PcmpAccountsReasonPayload } from '../types/pcmpProposal.types';
import { pcmpActionCallbacks } from '../utils/pcmpActionCallbacks';

/** Disbursement Failed of one proposal, before or after payout. */
export function useFailPcmpProposalAccounts(proposalId: number, onSuccess: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: PcmpAccountsReasonPayload) =>
      failPcmpProposalAccounts(proposalId, payload),
    ...pcmpActionCallbacks(queryClient, PCMP_ACCOUNTS_ACTION_COPY.FAIL.toast, onSuccess),
  });
}
